module.exports = __webpack_public_path__ + "assets/img/11.a6616695.jpg";